import React from 'react'

export default class MedicalData extends React.Component {
  render () {
    var medicalData = this.props.data.medicalData
    var presionArterialAlta = (medicalData.sistoleParado + medicalData.sistoleSentado) / 2
    var presionArterialBaja = (medicalData.diastoleParado + medicalData.diastoleParado) / 2
    var presionArterialTotal = presionArterialAlta + ' / ' + presionArterialBaja

    return (
      <div className='column-data-diabetes-report'>

        <div className='header-printable-report'>
          <div className='section-title'>Medidas antropométricas</div>
        </div>
        <div className=''>
          <div className='data-report-horizontal'>
            <div className='medical-data-report-container rborder'>
              <label><span className='data-title'>Peso: </span><span>{(typeof medicalData.peso === 'undefined') ? '' : medicalData.peso + ' kg'}</span></label>
            </div>
            <div className='medical-data-report-container rborder'>
              <label><span className='data-title'>Talla: </span><span>{(typeof medicalData.altura === 'undefined') ? '' : medicalData.altura + ' cm'}</span></label>
            </div>
            <div className='medical-data-report-container'>
              <label><span className='data-title'>IMC: </span><span className={this.props.data.IMCRange}>{this.props.data.patientIMC}</span></label></div>
          </div>
          <div className='sep-line'></div>
          <div className='data-report-horizontal'>
            <div className='medical-data-report-container pa-class'>
              <label><span className='data-title'>Perímetro abdominal: </span><span className={this.props.data.perAbdRange}>{(medicalData.perimetroAbdominal === null) ? '' : (typeof medicalData.perimetroAbdominal === 'undefined') ? '' : medicalData.perimetroAbdominal + ' cm'}</span></label>
            </div>
          </div>
        </div>
        <div className='header-printable-report hr-rep'>
          <div className='section-title'>Parámetros hemodinámicos</div>
        </div>
        <div className=''>
          <div className='data-report-horizontal'>
            <div className='medical-data-report-container rborder'>
              <label><span className='data-title'>P.A: </span><span className={this.props.data.presArRange}>{presionArterialTotal}</span></label>
            </div>
            <div className='medical-data-report-container rborder'>
              <label><span className='data-title'>VOP: </span><span className={this.props.data.vopRange}>{medicalData.vop}</span></label>
            </div>
            <div className='medical-data-report-container'>
              <label><span className='data-title'>FC: </span><span className={this.props.data.fcRange}>{(typeof medicalData.frecuencia === 'undefined') ? '' : medicalData.frecuencia + ' LPM'}</span></label></div>
          </div>
          <div className='sep-line'></div>
          <div className='data-report-horizontal'>
            <div className='medical-data-report-container pa-class'>
              <label>
                <span className='data-title'>ITB&nbsp;</span>
                <span className='data-title'> izquierdo: </span>
                <span className={this.props.data.itbiRange}>{medicalData.itbIzquierdo}&nbsp;</span>
                <span className='data-title'> derecho: </span>
                <span className={this.props.data.itbdRange}>{medicalData.itbDerecho}</span>
              </label>
            </div>
          </div>
        </div>
        <div className='header-printable-report'>
          <div className='section-title'>Riesgos de severidad</div>
        </div>
        <div className=''>
          <div className='sep-line'></div>
          <div className='data-report-horizontal'>
            <div className='medical-data-report-container pa-class'>
              <label><span className='data-title'>Tabaquísmo: </span><span className={this.props.data.tabaqRange}>{this.props.data.medicalData.fuma}</span></label>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

MedicalData.propTypes = {
  data: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/PrintableDiabetes/MedicalData.js